import { alpha, Box, Menu, MenuProps, styled } from "@mui/material";
import BackOfficeCompaniesFilters from "../components/backoffice-filters/BackOfficeCompaniesFilters";
import BackOffice from "../components/backoffice/BackOffice";
import BackOfficeHeader from "../components/backoffice-filters/BackOfficeHeader";
import SideBarBackOffice from "../components/general/SideBarBackOffice";

export const StyledMenu = styled((props: MenuProps) => (
    <Menu elevation={0} anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
    transformOrigin={{ vertical: 'top', horizontal: 'right' }} {...props}/> ))(({ theme }) => ({
    '& .MuiPaper-root': { borderRadius: 6, marginTop: theme.spacing(1), minWidth: 180, color: 'rgb(55, 65, 81)',
      boxShadow: 'rgb(255, 255, 255) 0px 0px 0px 0px, rgba(0, 0, 0, 0.05) 0px 0px 0px 1px, rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px',
      '& .MuiMenu-list': { padding: '4px 0' },
      '& .MuiMenuItem-root': { '& .MuiSvgIcon-root': { fontSize: 18, color: theme.palette.text.secondary, marginRight: theme.spacing(1.5) },
        '&:active': { backgroundColor: alpha( theme.palette.primary.main, theme.palette.action.selectedOpacity ) }},
      ...theme.applyStyles('dark', { color: theme.palette.grey[300] }),
    },
  }));

function BackOfficeCenter() {
    return (
        <Box sx={{ display: 'flex' }}>
            <Box sx={{ display: 'flex', flexDirection: 'column', paddingBlockStart: '60px', width: '100%'}} >
                <BackOfficeHeader />
                <BackOfficeCompaniesFilters />
                <BackOffice />
            </Box>
            
        </Box>
    );
  }
  
  export default BackOfficeCenter;